module.exports = __webpack_public_path__ + "img/1.c2c99464.jpg";